import React from "react";
import { Link } from "react-router-dom";
import "../css/Splash.css";
import "../css/Main.css";
import "../css/Quiz.css";

interface SplashPageProps {
  onStart: () => void;
}

const SplashPage: React.FC<SplashPageProps> = ({ onStart }) => {
  const handleStart = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    onStart();
  };

  return (
    <div>
      <h3 className="question-title content-container">
        Goat or Glory: Monty's Gauntlet
      </h3>
      <div className="quiz-container content-container">
        <div className="splash-content">
          <p className="narration">Do you understand the Monty Hall problem?</p>
          <p className="narration">
            But do you <b>really</b> understand it?
          </p>
          <p className="narration">
            Do you think you know better than the nearly 1,000 PhD students who
            wrote to Marilyn vos Savant's newsletter to refute her "incorrect"
            solution?
          </p>
          <p className="narration">
            Is your intuition and problem solving robust to changes in
            the game setup and rules?
          </p>
          <p className="narration"><b>Time to find out!</b></p>
          <div className="splash-button-container">
            <button className="start-button" onClick={handleStart}>
              Enter the Gauntlet
            </button>
          </div>
          <Link to="/llm-results" className="llm-results-cta">
            Curious how your favorite LLM did?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;
